'use strict';
/* jshint -W106 */

angular.module('shiftTraderApp')
  .factory('security', function (ServerUrls, $http, $location, Session, OAuthKeys, $rootScope, EventTrackingService, $q) {
    var security = {};

    security.setAccessTokenAndRedirect = function (accessToken, path) {
            Session.setAccessToken(accessToken);
            $http.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
            $location.path(path);
          };

    security.login = function (username, password) {
      return OAuthKeys.getKeys().then(function (response) {
        var data = {
          username: username,
          password: password,
          grant_type: 'password',
          client_id: response.data.uid,
          client_secret: response.data.secret
        };
        return $http.post(ServerUrls.current.railsApi + 'oauth/token', data)
          .then(function (resp) {
            if (resp && resp.data && resp.data.access_token && !_.isUndefined(resp.data.access_token) && !_.isNull(resp.data.access_token)) {
              Session.setAccessToken(resp.data.access_token);
            }

            if (resp && resp.data && resp.data.refresh_token && !_.isUndefined(resp.data.refresh_token) && !_.isNull(resp.data.refresh_token)) {
              Session.setRefreshToken(resp.data.refresh_token);
            }

            var priorSessionId = Session.getSessionId();
            Session.generateNewSessionId();
            EventTrackingService.addEvent('login_success', { new_uuid: Session.getSessionId(), old_uuid: priorSessionId });
            $rootScope.$broadcast('loginStateChanged', { state: true });
            return resp;
          }, function(resp) {
            EventTrackingService.addEvent('login_failure', { old_uuid: Session.getSessionId() });
            return $q.reject(resp);
          });
      });

    };

    return security;
  });
